import React, { useState } from "react";
import styles from "./home.module.css";
import { Link, Navigate } from "react-router-dom";
import Logo from "../../components/logo/logo";
import { useSelector } from "react-redux";
import type { RootState } from "../../services/store";
import Heading from "../../components/heading/heading";
import { Figure } from "../../components/figure/figure";

export function HomePage() {
  const { profile } = useSelector((state: RootState) => state.user);

  const hasCompleteProfile =
    !!profile && !!profile.interests?.length && !!profile.photos?.length;

  const [stage, setStage] = useState<number>(1);



  if (hasCompleteProfile) {
    return <Navigate to="/events" replace />;
  }


  return (
    <>
      <div className={styles.homeBox}>
        {stage === 1 && (
          <>
            <div className={styles.content}>
              <Logo />
              <div className={styles.title}>
                ХОТИТЕ НАЙТИ<br />
                <span className={styles.svoi}>СВОИХ</span> В МОСКВЕ?
              </div>

            </div>
            <div className="btn-container">
              <button className="btn-link" onClick={() => setStage(2)} >Далее</button>
            </div>
          </>
        )}
        {stage === 2 && (
          <>
            <div className={styles.content}>
              <p className={styles.titleStage2}>Добро пожаловать<br />в СВОИ!</p>
              <Figure />
              <div className={styles.textStage2}>Здесь взрослые люди находят<br /><span className="my-text-primary">друзей и компанию</span><br />
                на совместных <span className="my-text-primary">событиях</span></div>
            </div>
            <div className="btn-container">
              <button className="btn-link" onClick={() => setStage(3)} >Далее</button>
            </div>
          </>
        )}
        {stage === 3 && (
          <>
            <div className={styles.content}>
              <p>Выбирайте не только<br />мероприятие, но и <span className="my-text-primary">окружение</span></p>
              <Figure />
              <p>Смотрите <span className="my-text-primary">анкеты и фото</span><br />участников ещё до встречи</p>
            </div>
            <div className="btn-container">
              <Link className="btn-link" to="/profile-add" >Показать события<br />и участников</Link>
            </div>
          </>
        )}
      </div>
    </>
  );
}